export enum PaymentMethodId {
  BACS = "bacs", // 銀行轉帳
  COD = "cod", // 貨到付款
  ECPAY_CREDIT = "Wooecpay_Gateway_Credit", // 綠界信用卡一次付清
}

export enum ShippingMethodId {
  FLAT_RATE = "flat_rate",
  ECPAY_CVS_711 = "Wooecpay_Logistic_CVS_711",
  ECPAY_CVS_FAMILY = "Wooecpay_Logistic_CVS_Family",
  ECPAY_CVS_HILIFE = "Wooecpay_Logistic_CVS_Hilife",
  ECPAY_CVS_OKMART = "Wooecpay_Logistic_CVS_Okmart",
  // ECPAY_HOME_TCAT = "Wooecpay_Logistic_Home_Tcat",
  // ECPAY_HOME_POST = "Wooecpay_Logistic_Home_Post",
  // LOCAL_PICKUP = "local_pickup", // 自取
}

export enum ShippingMethodType {
  CVS = "CVS",
  Home = "Home",
  Invaild = "Invaild",
  // LocalPickup = "LocalPickup",
}

export enum CvsTypeName {
  CVS_711 = "7-11",
  CVS_FAMILY = "全家",
  CVS_HILIFE = "萊爾富",
  CVS_OKMART = "OK 超商",
}

export enum SortOrderBy {
  DATE = "date",
  POPULARITY = "popularity",
  PRICE = "price",
}

export enum SortDirection {
  ASC = "asc",
  DESC = "desc",
}

export const enum SortOptions {
  DEFAULT = "",
  DATE = "date",
  POPULARITY = "popularity",
  PRICE_ASC = "price-asc",
  PRICE_DESC = "price-desc",
}

// 對應後台上架分類 slug
export const enum ProductCategorySlug {
  ReadyToShip = "ready-to-ship", // 現貨
  Flavor = "flavor", // 風味調性
  GrowingAreas = "growing-areas", // 產區
}

export const enum CheckoutStepsEnum {
  CART = "cart",
  CHECKOUT = "checkout",
  PAYMENT = "payment",
  COMPLETE = "complete",
}
